import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { Pdfcontract } from '../_models/pdfcontract';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from './index';


@Injectable()
export class PdfcontractsService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService) {
  }


  getAll(): Observable<Pdfcontract[]> {

    let pdfcontracts$ = this.http
      .get(`${this.baseUrl}/pdfcontracts`, this.makeHeaders())
      .map(mapPdfcontracts)
      .catch(handleError);
    return pdfcontracts$;
  }
  // new change -- add function for get dealer pdfcontracts
  getByDealer(id: string, type: string): Observable<Pdfcontract[]> {
    let pdfcontracts$ = this.http
      .get(`${this.baseUrl}/pdfcontracts?dealer_id=${id}&type=${type}`, this.makeHeaders())
      .map(mapPdfcontracts)
      .catch((error: any) => {
        // Handle 404 (no pdf contracts found) gracefully
        if (error.status === 404) {
          console.log('No pdf contracts found for dealer:', id, 'type:', type);
          return Observable.of([]); // Return empty array instead of error
        }
        // For other errors, use the standard error handling
        return handleError(error);
      });
    return pdfcontracts$;
  }

  get(id: string, type: string): Observable<Pdfcontract> {
    let pdfcontract$ = this.http
      .get(`${this.baseUrl}/pdfcontracts/${id}/${type}`, this.makeHeaders())
      .map(mapPdfcontract);
    return pdfcontract$;
  }
  // save(person: Person) : Observable<Response>{
  //   // this won't actually work because the StarWars API doesn't
  //   // is read-only. But it would look like this:
  //   return this.http
  //     .put(`${this.baseUrl}/people/${person.id}`, JSON.stringify(person), {headers: this.getHeaders()});
  // }
  save(pdfcontract: Pdfcontract): Observable<Response> {
    // this won't actually work because the StarWars API doesn't
    // is read-only. But it would look like this:
    return this.http
      .put(`${this.baseUrl}/pdfcontracts/${pdfcontract._id}`, JSON.stringify(pdfcontract), this.makeHeaders());
  }
  savePdfcontract(pdfcontract: Pdfcontract): Observable<Response> {
    // this won't actually work because the StarWars API doesn't
    // is read-only. But it would look like this:
    return this.http
      .put(`${this.baseUrl}/pdfcontracts/${pdfcontract._id}`, JSON.stringify(pdfcontract), this.makeHeaders());
  }
  create(pdfcontract: Pdfcontract): Observable<Pdfcontract> {
    let newpdfcontract = this.http
      .post(`${this.baseUrl}/pdfcontracts`, JSON.stringify(pdfcontract), this.makeHeaders())
      .map(mapPdfcontract);
    return newpdfcontract;
  }
  update(pdfcontract: Pdfcontract): Observable<Response> {
    return this.http
      .put(`${this.baseUrl}/pdfcontracts/${pdfcontract._id}`, JSON.stringify(pdfcontract), this.makeHeaders());
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json ');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json ');

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapPdfcontracts(response: Response): Pdfcontract[] {
  // uncomment to simulate error:
  // throw new Error('ups! Force choke!');
  return response.json().map(toPdfcontract);
}

function toPdfcontract(r: any): Pdfcontract {
  let pdfcontract = <Pdfcontract>({
    _id: r._id,
    contract: r.contract,
    dealer_id: r.dealer_id,
    email: r.email,
    tc: r.tc,
    offer: r.offer,
    confirmation: r.confirmation,
    offerConfirmation: r.offerConfirmation,
    type: r.type
  });
  // console.log('Parsed pdfcontract:', pdfcontract);
  return pdfcontract;
}

function mapPdfcontract(response: Response): Pdfcontract {
  // toPerson looks just like in the previous example
  return toPdfcontract(response.json());
}

// this could also be a private method of the component class
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/pdfcontracts.service.ts